import { useQuery } from "@tanstack/react-query";
import { SPACE_SETTINGS_KEY } from "../constants/queries";
import SpaceSettingsService from "modules/admin/services/spaceSetting.service";

export const useFindSettingsSpaces = () => {
  const {
    data: space,
    isLoading: isLoadingSpace,
    isError: isErrorSpace,
  } = useQuery([SPACE_SETTINGS_KEY], SpaceSettingsService.search);

  return {
    space, isLoadingSpace, isErrorSpace
  }
}